export const DEFAULT_SONG = "flying-harmonicas-1";

export const originals = {
    "Flying Harmonicas": "flying-harmonicas-1",
    "I'm a Honeybee": "im-a-honeybee",
    "Mama's Birthday": "mamas-birthday",
    "On the Road to Inner Sanctum": "on-the-road-to-inner-sanctum-01-08-2025",
    "Sprayed By Skunk v. 3": "sprayed-by-skunk-3",
    Sunflower: "sunflower",
    "The Day Was Not Ready for Darkness": "without-the-darkness-theres-light",
    "We Share the Same Sky": "we-share-the-same-sky-1",
};

export const covers = {
    "Aloha Week Hula": "aloha-week-hula",
    "Between the Devil and the Deep Blue Sea":
        "between-the-devil-and-the-deep-blue-sea",
    "City of Stars": "city-of-stars-steve",
    "Koke'e": "kokee",
    "Slow Down": "slow-down",
    "Sunshine On My Shoulders": "sunshine-on-my-shoulders",
    "Sweet Child of Mine (Steel Guitar)": "sweet-child-of-mine-steel",
    "Thank You Girl": "thank-you-girl",
    "Will You Still Love Me Tomorrow (Dance Version)":
        "will-you-still-love-me-tomorrow-dance-version",
};

export const collabs = {};
